import { render, staticRenderFns } from "./JiuciContent.vue?vue&type=template&id=c5885136&scoped=true"
import script from "./JiuciContent.vue?vue&type=script&lang=js"
export * from "./JiuciContent.vue?vue&type=script&lang=js"
import style0 from "./JiuciContent.vue?vue&type=style&index=0&id=c5885136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5885136",
  null
  
)

export default component.exports